import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { VerticalNavigation, VerticalNavLink } from './VerticalNavigation';
import { NotificationBell } from '../modules/Notifications';
import { useAuth } from '../modules/Authentication';
import { usePageTitle } from './usePageTitle';
import './AdminLayout.css';

const NAV_ITEMS = [
    { to: '/admin/dashboard', iconName: 'chart-pie', label: 'داشبورد', end: true },
    { to: '/admin/users', iconName: 'person-group', label: 'مدیریت کاربران' },
    { to: '/admin/user-groups', iconName: 'target', label: 'گروه‌های کاربری' },
    { to: '/admin/operators', iconName: 'person', label: 'مدیریت اپراتورها' },
    { to: '/admin/ekyc-queue', iconName: 'shield-star', label: 'بررسی احراز هویت' },
    { to: '/admin/evidence-review', iconName: 'document-duplicate', label: 'بررسی مدارک' },
    { to: '/admin/all-evidence', iconName: 'archive', label: 'همه مدارک' },
    { to: '/admin/certificates', iconName: 'document', label: 'مدیریت گواهی‌ها' },
    { to: '/admin/certificate-profiles', iconName: 'clipboard', label: 'پروفایل‌های گواهی' },
    { to: '/admin/products', iconName: 'shopping-bag', label: 'مدیریت محصولات' },
    { to: '/admin/settings', iconName: 'gear', label: 'تنظیمات' },
    { to: '/admin/terms', iconName: 'document', label: 'قوانین و مقررات' },
    { to: '/admin/payments', iconName: 'card', label: 'مدیریت پرداخت‌ها' },
    { to: '/admin/operations', iconName: 'shield-star', label: 'عملیات سیستمی', end: true },
    { to: '/admin/operations/health', iconName: 'shield-star', label: 'سلامت سرویس‌ها' },
    { to: '/admin/operations/queue', iconName: 'inbox-stack', label: 'صف عملیات' },
    { to: '/admin/operations/dlq', iconName: 'triangle-warning', label: 'صف مرگ' },
    { to: '/admin/operations/compensation', iconName: 'arrow-path', label: 'کارهای جبرانی' },
    { to: '/admin/tickets', iconName: 'ticket', label: 'مدیریت تیکت‌ها' },
    { to: '/admin/activity-logs', iconName: 'clock-filled', label: 'لاگ فعالیت‌ها' },
    { to: '/admin/profile', iconName: 'person', label: 'پروفایل' },
];

function AdminLayout() {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const pageTitle = usePageTitle(NAV_ITEMS, (item) => item.to);

    const handleLogout = async () => {
        await logout();
        navigate('/admin/login');
    };

    const items = NAV_ITEMS.map(({ to, iconName, label, end }) => ({
        name: to,
        component: () => (
            <VerticalNavLink href={to} iconName={iconName} end={end}>
                {label}
            </VerticalNavLink>
        ),
    }));

    return (
        <div className="admin-layout">
            <VerticalNavigation
                items={items}
                profileHref="/admin/profile"
                releaseHref="/admin/releases"
                setupGuideHref="/guide/admin"
                helpHref="/help/admin"
                onLogout={handleLogout}
            />
            <main className="admin-layout-main">
                <header className="admin-topbar">
                    <span className="admin-topbar-title"></span>
                    <div className="admin-topbar-actions">
                        <NotificationBell scope="admin" />
                    </div>
                </header>
                <Outlet />
            </main>
        </div>
    );
}

export default AdminLayout;